module.exports = __webpack_public_path__ + "static/media/LESStreetBelowHighLineA0005_bg_clean_v001.a3db7a37.webp";